import { ISectionType } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
class SectionTypeBadge {
  private sectionType: ISectionType;
  private courseNk: string;
  private maxChar: number;
  private textClass: string;
  private showAsDisabled: boolean;
  private sectionTypeBadgeClassName: string;
  private truncatedSectionTypeName: string;

  constructor(private getCSSClassForString: any) {}

  getSectionTypeBadgeClassName(courseNk: string) {
    let badgeStyleClass = `${this.getCSSClassForString(courseNk, 'bdr')} ${this.getCSSClassForString(
      courseNk,
      'bkg'
    )} bas bdr-solid `;
    badgeStyleClass += !this.showAsDisabled
      ? `clr-gray-txt`
      : ` ${this.getCSSClassForString(courseNk)} ${this.textClass}`;
    return badgeStyleClass;
  }

  $onInit() {
    this.maxChar = this.maxChar || 25;
    this.textClass = this.textClass || ``;
    this.showAsDisabled = this.showAsDisabled || false;
    this.sectionTypeBadgeClassName = this.getSectionTypeBadgeClassName(this.courseNk);
    this.truncatedSectionTypeName = _4.startCase(
      _4.lowerCase(_4.truncate(_4.get(this.sectionType, 'name', ''), { length: this.maxChar }))
    );
  }

  $onChanges(changes: any) {
    if (changes.maxChar && changes.maxChar.currentValue) {
      this.maxChar = changes.maxChar.currentValue;
    }
    if (changes.showAsDisabled && 'currentValue' in changes.showAsDisabled) {
      this.showAsDisabled = changes.showAsDisabled.currentValue;
    }
    if (changes.courseNk && changes.courseNk.currentValue) {
      this.courseNk = changes.courseNk.currentValue;
    }
    if (changes.sectionType && changes.sectionType.currentValue) {
      this.truncatedSectionTypeName = _4.truncate(_4.get(changes, 'sectionType.currentValue.name', ''), {
        length: this.maxChar
      });
    }
    if (changes.textClass && changes.textClass.currentValue) {
      this.textClass = changes.textClass.currentValue;
    }
    this.sectionTypeBadgeClassName = this.getSectionTypeBadgeClassName(this.courseNk);
  }
}

class SectionTypeBadgeComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      sectionType: '<',
      courseNk: '<',
      maxChar: '<',
      textClass: '<',
      showAsDisabled: '<'
    };
    this.controller = SectionTypeBadge;
    this.templateUrl = 'capability-ng-scheduler/src/views/components/section_type_badge/section_type_badge.html';
  }
}
angular.module('capability-ng-scheduler').component('sectionTypeBadge', new SectionTypeBadgeComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/section_type_badge/section_type_badge.ts